import { render, staticRenderFns } from "./TerraPatientIntegrationDialog.vue?vue&type=template&id=c73324e8"
import script from "./TerraPatientIntegrationDialog.vue?vue&type=script&lang=js"
export * from "./TerraPatientIntegrationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports